import { render, staticRenderFns } from "./LangBtn.vue?vue&type=template&id=656229ce&scoped=true"
import script from "./LangBtn.vue?vue&type=script&lang=ts"
export * from "./LangBtn.vue?vue&type=script&lang=ts"
import style0 from "./LangBtn.vue?vue&type=style&index=0&id=656229ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656229ce",
  null
  
)

export default component.exports